<template>
  <g>
    <path d="M3 3H9V5H5V9H3V3Z" />
    <path d="M3 21H9V19H5V15H3V21Z" />
    <path d="M15 21H21V15H19V19H15V21Z" />
    <path d="M21 3H15V5H19V9H21V3Z" />
  </g>
</template>
